import SubscribeSection from '../../../UI/SubscribeSection/SubscribeSection';
import { Grid, Typography } from '@mui/material';

const HeroBanner = () => {
  return (
    <Grid
      container
      spacing={{ xs: 4, lg: 2 }}
      alignItems='center'
      sx={{ pt: { xs: '3rem', lg: '0rem' } }}
      justifyContent='center'>
      <Grid item lg={6}>
        <Typography variant='body1' sx={{ color: 'info.main', fontWeight: 'thin' }}>
          MY FIRST 100
        </Typography>
        <Typography variant='h3' component='h1' sx={{ fontWeight: 'bold' }}>
          Learn how people are starting successful{' '}
          <Typography variant='h3' component='span' sx={{ color: 'secondary.main', fontWeight: 'bold' }}>
            businesses.
          </Typography>
        </Typography>
        <Typography variant='body1' sx={{ my: '2rem' }}>
          <Typography variant='body1' component='span' sx={{ fontWeight: 'bold' }}>
            My First 100
          </Typography>{' '}
          shares case studies of what founders did in their first 100 days to build the foundations of their businesses
          that currently serve thousands to millions of customers.
        </Typography>
      </Grid>
      <SubscribeSection />
    </Grid>
  );
};

export default HeroBanner;
